import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Clientes from "./pages/Clientes";
import Usuarios from "./pages/Usuarios";
import Dashboard from "./pages/Dashboard";
import Mercaderia from "./pages/Mercaderia";
import MaterialesProduccion from "./pages/MaterialesProduccion";
import Notificaciones from "./pages/Notificaciones";
import Operaciones, { OperacionesOrdenes } from "./pages/Operaciones";
import Productos from "./pages/Productos";
import Proveedores from "./pages/Proveedores";
import TrackingMercaderia from "./pages/TrackingMercaderia";
import TrackingOrden from "./pages/TrackingOrden";
import AppLayout from "./components/AppLayout";

const RutaPrivada = ({ children }) => {
  const { autenticado, verificando } = useAuth();
  if (verificando) return <div className="loading-state">Validando sesion...</div>;
  return autenticado ? children : <Navigate to="/login" replace />;
};

const RutaLogin = () => {
  const { autenticado, verificando } = useAuth();
  if (verificando) return <div className="loading-state">Validando sesion...</div>;
  return autenticado ? <Navigate to="/" replace /> : <Login />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<RutaLogin />} />
    <Route path="/tracking/:codigoTracking" element={<TrackingMercaderia />} />
    <Route path="/tracking/orden/:tipo/:codigo" element={<TrackingOrden />} />
    <Route
      path="/"
      element={
        <RutaPrivada>
          <AppLayout />
        </RutaPrivada>
      }
    >
      <Route index element={<Dashboard />} />
      <Route path="clientes" element={<Navigate to="/clientes/pacientes" replace />} />
      <Route path="clientes/pacientes" element={<Clientes tipoCliente="Paciente" />} />
      <Route path="clientes/profesionales" element={<Clientes tipoCliente="Profesional" />} />
      <Route path="proveedores" element={<Proveedores />} />
      <Route path="productos" element={<Productos />} />
      <Route path="mercaderia" element={<Mercaderia />} />
      <Route path="materiales-produccion" element={<MaterialesProduccion />} />
      <Route path="notificaciones" element={<Notificaciones />} />
      <Route path="operaciones" element={<Operaciones />} />
      <Route path="operaciones/pedidos" element={<OperacionesOrdenes tipo="pedidos" />} />
      <Route path="operaciones/fraccionamiento" element={<OperacionesOrdenes tipo="fraccionado" />} />
      <Route path="operaciones/produccion" element={<OperacionesOrdenes tipo="produccion" />} />
      <Route path="usuarios" element={<Usuarios />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
